import React, {useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import LiveAlertsTable from '../layouts/components/live/LiveAlertsTable';
import LiveAlertItem from '../layouts/components/live/LiveAlertItem';
import Toolbar from '../layouts/components/live/Toolbar';
import {AlertLiveObject, BookmakerData, EventsStoredObjects, LiveSettingsObject, User,} from '../@types/response';
import {getBookmakers} from '../store/selectors/getBookmakers';
import {getLiveAlerts} from '../store/selectors/live/getLiveAlerts';
import {GetInitAction} from '../store/actions/live/GetInitAction';
import BookLiveModal from '../layouts/components/live/modals/BookLiveModal';
import getClient from '../store/selectors/getClient';
import SignChartModal from '../layouts/components/modals/SignChartModal';
import LiveEventDetailsModal from '../layouts/components/live/modals/LiveEventDetailsModal';
import HideLiveModal from "../layouts/components/live/modals/HideLiveModal";
import {AppDispatch} from "recharts/types/state/store";
import {getFixtures} from "../store/selectors/getFixtures";
import {getEvents} from "../store/selectors/live/getEvents";
import {getSettings} from "../store/selectors/live/getSettings";
import {sortEvent} from "../store/utils/liveUtils";
import {GetAlertsAction} from "../store/actions/live/GetAlertsAction";

const Live: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();

    const fixtures: EventsStoredObjects = useSelector(getFixtures);
    const eventsData = useSelector(getEvents);
    const events: EventsStoredObjects = Object.fromEntries(
            Object.entries({...eventsData, ...fixtures}).map(([id, _]) => {
                const fixture = fixtures[id] ?? {};
                const event: any = eventsData[id] ?? {};
                return [id, {...event, ...fixture}];
            })
    );
    const lives: AlertLiveObject[] = useSelector(getLiveAlerts);
    const bookmakers: BookmakerData = useSelector(getBookmakers);
    const client: undefined | User = useSelector(getClient);
    const settings: LiveSettingsObject = useSelector(getSettings);

    const sortedLives = useMemo(() =>
                    [...lives].sort((a, b) => sortEvent(a, b, events, settings)),
            [lives, events, settings]
    );

    const enabledBookmakers: Set<number> = useMemo(() => {
        return new Set(Object.keys(bookmakers)
                .map((b) => parseInt(b)))
    }, [bookmakers])

    useEffect(() => {
        dispatch(GetInitAction(client?.id || ''));
        dispatch(GetAlertsAction());
        document.title = 'LIVE - OddMonitor';
    }, []);

    if (!Object.keys(bookmakers).length) {
        return (
                <div>
                    <div
                            id='toolbar-live'
                            className='bg-toolbar-bgMain border-b border-toolbar-borderBottom fixed top-0 right-0 flex items-end justify-around w-full z-10'
                    >
                        <Toolbar/>
                    </div>
                    <div className='mt-16'>
                        <LiveAlertsTable/>
                    </div>
                    <div>Loading</div>
                </div>
        );
    }

    return <React.Fragment>
        <div
                id='toolbar-live'
                className='bg-toolbar-bgMain border-b border-toolbar-borderBottom fixed top-0 right-0 flex items-end justify-around w-full z-10'
        >
            <Toolbar/>
        </div>
        <div className='mt-16 mx-4'>
            <LiveAlertsTable>
                {sortedLives
                        //TODO: move this check in utils?
                        .filter(alert => enabledBookmakers.has(alert.bookmakerId) && (client?.client == null || client.client === alert.bookmakerId))
                        .map((alert: AlertLiveObject, idx: number) => <LiveAlertItem alert={alert}
                                                                                     key={`${alert.id}x${idx}`}
                                                                                     event={events[alert.id]}/>)}
            </LiveAlertsTable>
        </div>

        <LiveEventDetailsModal/>
        <BookLiveModal/>
        <SignChartModal/>
        <HideLiveModal/>
    </React.Fragment>;
};

export default Live;
